export const RESEND_VERIFY_OTP = "RESEND_VERIFY_OTP"
export const RESEND_VERIFY_OTP_SUCCESSFUL = "RESEND_VERIFY_OTP_SUCCESSFUL"
export const RESEND_VERIFY_OTP_FAILED = "RESEND_VERIFY_OTP_FAILED"
export const RESEND_VERIFY_OTP_RESET = "RESEND_VERIFY_OTP_RESET"